// Step3Preferences.jsx
// Step 3: Preferences

import React from 'react';
import { MapPin, Building, BookOpen } from 'lucide-react';
import SelectField from '../../components/ui/SelectField';
import CollegePicker from '../../components/CollegePicker';

const Step3Preferences = ({ formData, updateField }) => {

  const educationFormatOptions = [
    'On Campus',
    'Online',
    'Hybrid',
    'HyFlex',
    'Learn Anywhere'
  ];

  const majorOptions = [
    'Accounting',
    'Anthropology',
    'Architecture',
    'Art History',
    'Biology',
    'Business Administration',
    'Chemistry',
    'Civil Engineering',
    'Communications',
    'Computer Science',
    'Criminal Justice',
    'Economics',
    'Electrical Engineering',
    'English',
    'Environmental Science',
    'Finance',
    'Graphic Design',
    'History',
    'Information Technology',
    'International Relations',
    'Journalism',
    'Marketing',
    'Mathematics',
    'Mechanical Engineering',
    'Music',
    'Nursing',
    'Philosophy',
    'Physics',
    'Political Science',
    'Psychology',
    'Public Health',
    'Sociology',
    'Theater',
    'Undecided'
  ];

  return (
    <div>
      <h1 className="text-3xl font-bold mb-2" style={{ color: '#2A2F35' }}>
        Preferences
      </h1>
      <p className="text-base mb-6" style={{ color: '#6B7280' }}>
        What are you looking for in a college?
      </p>

      <div className="space-y-4">
        {/* Education Format */}
        <SelectField
          label="Education Format"
          value={formData.preferred_learning_mode}
          onChange={(value) => updateField('preferred_learning_mode', value)}
          placeholder="Select format"
          options={educationFormatOptions}
          required
        />

        {/* College Size */}
        <SelectField
          label="College Size"
          value={formData.college_size}
          onChange={(value) => updateField('college_size', value)}
          icon={<Building size={20} />}
          placeholder="Select size preference"
          options={[
            'Small',
            'Medium',
            'Large',
            'Very Large'
          ]}
        />

        {/* Distance from Home */}
        <SelectField
          label="Distance from Home"
          value={formData.distance_from_home}
          onChange={(value) => updateField('distance_from_home', value)}
          icon={<MapPin size={20} />}
          placeholder="Select distance preference"
          options={[
            'Close to home',
            'Moderate distance',
            'Far from home',
            'Anywhere'
          ]}
        />

        {/* Intended Major */}
        <SelectField
          label="Intended Major"
          value={formData.intended_major}
          onChange={(value) => updateField('intended_major', value)}
          icon={<BookOpen size={20} />}
          placeholder="Select your major"
          options={majorOptions}
          required
        />

        {/* Alternate Major */}
        <SelectField
          label="Alternate Major"
          value={formData.alternate_major}
          onChange={(value) => updateField('alternate_major', value)}
          icon={<BookOpen size={20} />}
          placeholder="Select alternate major (optional)"
          options={majorOptions}
        />

        {/* Colleges You're Considering */}
        <CollegePicker
          value={formData.saved_colleges || []}
          onChange={(colleges) => updateField('saved_colleges', colleges)}
        />
      </div>
    </div>
  );
};

export default Step3Preferences;
